/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PremiumRoleEntity } from './premiumRoleEntity';
import { GeoLocationEntity } from './geoLocationEntity';
import { NotificationsEntity } from './notificationsEntity';
import { UserSportTypeLevelDto } from './userSportTypeLevelDto';
import { CommissionEntity } from './commissionEntity';


export interface UpdateMyProfileDto { 
    avatarUrl?: string;
    city?: string;
    country?: string;
    zipCode?: string;
    language?: string;
    dateOfBirth?: string;
    description?: string;
    timezone?: string;
    firstName?: string;
    lastName?: string;
    likeds?: Array<string>;
    location?: GeoLocationEntity;
    privacy?: UpdateMyProfileDto.PrivacyEnum;
    pushToken?: string;
    sex?: string;
    sportLevels?: Array<UserSportTypeLevelDto>;
    work?: string;
    isDisplayNameAnonym?: boolean;
    notifications?: NotificationsEntity;
    premiumRole?: PremiumRoleEntity;
    commissionPercent?: number;
    acceptedCommission?: boolean;
    commissionId?: string;
    commission?: CommissionEntity;
    locationEnabled?: boolean;
    appearInNearbyCount?: boolean;
    locationCity?: string;
    liveLocation?: GeoLocationEntity;
}
export namespace UpdateMyProfileDto {
    export type PrivacyEnum = 'public' | 'private' | 'hidden';
    export const PrivacyEnum = {
        Public: 'public' as PrivacyEnum,
        Private: 'private' as PrivacyEnum,
        Hidden: 'hidden' as PrivacyEnum
    };
}


